import { render, staticRenderFns } from "./addpurchase.vue?vue&type=template&id=8e6b1e94&scoped=true&"
import script from "./addpurchase.vue?vue&type=script&lang=js&"
export * from "./addpurchase.vue?vue&type=script&lang=js&"
import style0 from "./addpurchase.vue?vue&type=style&index=0&id=8e6b1e94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6b1e94",
  null
  
)

export default component.exports